<template>
	<div 
		class="compact-banner" 
		:class="cssClass"
		:style="gradientStyle"
	>
		<complex-background-big 
			v-if="showComplexBackground"
			:include-left-blobs="true" 
		/>
		<banner-grid-overlay 
			v-if="gridColor"
			:grid-color="gridColor" 
		/>
		<slot></slot>
	</div>
</template>

<script>
import ComplexBackgroundBig from '@/components/designElements/ComplexBackgroundBig.vue'
import BannerGridOverlay from '@/components/PromoBanners/BannerGridOverlay.vue'

export default {
	name: 'CompactBanner',
	components: {
		ComplexBackgroundBig,
		BannerGridOverlay
	},
	props: {
		gradientColors: {
			type: Object,
			default: null
		},
		showComplexBackground: {
			type: Boolean,
			default: false
		},
		gridColor: {
			type: String,
			default: null
		},
		cssClass: {
			type: String,
			default: ''
		}
	},
	computed: {
		gradientStyle() {
			if (!this.gradientColors) return null
			
			// Support three-color gradients if tertiary is provided
			if (this.gradientColors.tertiary) {
				return {
					background: `linear-gradient(135deg, ${this.gradientColors.primary} 0%, ${this.gradientColors.secondary} 50%, ${this.gradientColors.tertiary} 100%)`
				}
			}
			
			// Default two-color gradient
			return {
				background: `linear-gradient(135deg, ${this.gradientColors.primary} 0%, ${this.gradientColors.secondary} 100%)`
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.compact-banner {
	position: relative;
	width: 100%;
	height: 160px;
	border-radius: 12px;
	padding: 35px;
	overflow: hidden;
	display: flex;
	align-items: center;
	
	// Mobile styling
	@media (max-width: 959px) {
		height: 200px;
		border-radius: 0 !important;
		margin: 0 !important;
		padding: 35px;
	}
}
</style> 